import { Component, OnInit } from '@angular/core';
import { Submission } from "../../classes/submission";
import { ModelService } from '../../model.service';
import {Router} from '@angular/router';


@Component({
  selector: 'app-submissions',
  templateUrl: './submissions.component.html',
  styleUrls: ['./submissions.component.css']
})
export class SubmissionsComponent implements OnInit {

  title = 'Submissions';
  submissions: Submission[];
  user = JSON.parse(localStorage.getItem('currentUser'));
  user_name = this.user.name;
  team_name = this.user.team_name;

  constructor(private modelService: ModelService, private router: Router) { }

  ngOnInit() {
    this.getSubmissions();
  }

  getSubmissions(): void {
  this.modelService.getSubmissions().subscribe(submissions => {

    this.submissions = [];
    let submission_id = 0;

    for(let n=0; n<submissions.length; n++)
    {
      if(submissions[n].submission_id != submission_id)
      {
        this.submissions.push(submissions[n]);
        submission_id = submissions[n].submission_id;
      }
      else
      {
        this.submissions[this.submissions.length-1].challenge += (", " + submissions[n].challenge);
      }

    }

  },  err => {
        console.log("Error occured.")
        this.router.navigateByUrl('login');
      });
}

}



// WEBPACK FOOTER //
// /Users/boshaughnessy/Documents/Web/ClonkeenChallenge/clonkeen-challenge/src/app/content/submissions/submissions.component.ts